import { AccessGroupType } from '../enums/access-group-type.enum';
import { BackEndDirectory, Directory } from './directory';

export class AccessGroup {
  public id: string;
  public name: string;
  public description: string;
  public type: AccessGroupType;
  public directory?: Directory;

  constructor(backendAccessGroup?: BackendAccessGroup) {
    if (backendAccessGroup) {
      this.id = backendAccessGroup.id;
      this.name = backendAccessGroup.name;
      this.description = backendAccessGroup.description;
      this.type = backendAccessGroup.type;
      this.directory = backendAccessGroup.directory ? new Directory(backendAccessGroup.directory) : null;
    }
  }

  public toBackend(): BackendAccessGroup {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      type: this.type,
      directory: this.directory?.toBackend(),
    };
  }
}

export interface BackendAccessGroup {
  id: string;
  name: string;
  description: string;
  type: AccessGroupType;
  directory?: BackEndDirectory;
}
